import { createStore, combineReducers } from "redux";
import { diagnoseReducer } from "./diagnosestate/diagnoseReducer";
import { searchReducer } from "./searchState/searchReducer";
import { loaderReducer } from "./loader/loaderReducer";
import { managetimeReducer } from "./managetime/managetimeReducer";
import { printReducer } from "./printstate/printReducer";
import { paymentReducer } from "./paymentState/paymentReducer";
import { patientsReducer } from "./patients/patientsReducer";
import { appointmentReducer } from "./appointment/appointmentReducer";
import { doctorReducer } from "./doctor/doctorReducer";
import { prescriptionReducer } from "./printstate/prescriptionReducer";
import { printTemplate2Reducer } from "./printstate/printTemplate2Reducer";
import { tokenPrintReducer } from "./printstate/tokenPrintReducer";
import { bookclinicReducer } from "./bookclinic/bookclinicreducer";
import { makeappointmentReducer } from "./makanappointment/makappointment";
const rootReducer = combineReducers({
  diagnose: diagnoseReducer,
  searching: searchReducer,
  loader: loaderReducer,
  managetime: managetimeReducer,
  print: printReducer,
  preprint: prescriptionReducer,
  printTemplate2: printTemplate2Reducer,
  tokenPrint: tokenPrintReducer,
  payment: paymentReducer,
  patients: patientsReducer,
  appointment: appointmentReducer,
  doctor: doctorReducer,
  booking: bookclinicReducer,
  makeappointment: makeappointmentReducer,
});
const store = createStore(rootReducer);

export type RootState = ReturnType<typeof rootReducer>;
export default store;
